import { Modal, Row, Col } from "antd";
import { Box, Flex, Text } from "@chakra-ui/react";
import SelectUnidade from "components/Input/SelectUnidade";
import { useState } from "react";
import OutlineButton from "ui/components/Button/OutlineButton";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import SelectPessoas from "components/Input/SelectPessoas";
import { TipoEntidadeEnum } from "resources/enums/conta";
import {
  FiltroEncomenda,
  filtroDefaultEncomenda,
} from "../ListaEncomendaTable/hooks/useFiltroEncomenda";

interface ModalFiltroEncomendaProps {
  tenantId: string;
  visible: boolean;
  onClose: () => any;
  filtro: FiltroEncomenda;
  onChangeFiltro: (filtro: Partial<FiltroEncomenda>) => any;
}

export default function ModalFiltroEncomenda({
  filtro,
  tenantId,
  visible,
  onChangeFiltro,
  onClose,
}: ModalFiltroEncomendaProps) {
  const [localFiltro, setLocalFiltro] = useState(filtro);

  const numeroFiltroSelecionados =
    (localFiltro.pessoaId?.length ? 1 : 0) +
    (localFiltro.unidadeId?.length ? 1 : 0);

  return (
    <Modal
      destroyOnClose
      width={"600px"}
      onCancel={onClose}
      centered
      title="Filtros avançados"
      visible={visible}
      footer={
        <Flex justifyContent="end" gap={4}>
          <OutlineButton onClick={onClose}>Fechar</OutlineButton>
          <OutlineButton
            onClick={() => {
              onChangeFiltro(filtroDefaultEncomenda);
              setLocalFiltro((state) => ({
                ...state,
                unidadeId: "",
                pessoaId: "",
              }));
              onClose();
            }}
          >
            Limpar Filtros
          </OutlineButton>
          <PrimaryButton
            onClick={() => {
              onChangeFiltro({
                pessoaId: localFiltro.pessoaId,
                unidadeId: localFiltro.unidadeId,
              });
              onClose();
            }}
          >
            Filtrar
            {typeof numeroFiltroSelecionados === "number" &&
            numeroFiltroSelecionados > 0
              ? ` (${numeroFiltroSelecionados})`
              : null}
          </PrimaryButton>
        </Flex>
      }
    >
      <Box as={Row} gap={4}>
        <Col md={11}>
          <Text mb="2px" fontSize="13px">
            Unidade
          </Text>
          <SelectUnidade
            tenantId={tenantId}
            onChange={(unidadeId) => {
              setLocalFiltro((state) => ({
                ...state,
                unidadeId,
                pessoaId: "",
              }));
            }}
            value={localFiltro.unidadeId}
          />
        </Col>

        <Col md={11}>
          <Text mb="2px" fontSize="13px">
            Morador
          </Text>
          <SelectPessoas
            tipoEntidades={[TipoEntidadeEnum.Condomino]}
            unidadeId={localFiltro.unidadeId}
            value={localFiltro.pessoaId}
            onChange={(pessoaId) => {
              setLocalFiltro((state) => ({ ...state, pessoaId }));
            }}
          />
        </Col>
      </Box>
    </Modal>
  );
}
